import { Progress } from "@/components/ui/progress";

interface ScoreCellProps {
  score: number | undefined | null;
  max?: number;
  showLabel?: boolean;
  className?: string;
}

export function ScoreCell({ 
  score, 
  max = 100, 
  showLabel = true,
  className = "" 
}: ScoreCellProps) {
  // Coerce score to a finite number
  const value = typeof score === "number" && Number.isFinite(score) ? score : 0;
  
  // Validate max as a finite positive number
  const validMax = Number.isFinite(max) && max > 0 ? max : 0;
  
  // Compute percentage only when max > 0, otherwise set to 0
  const percentage = validMax > 0 
    ? Math.min(100, Math.max(0, (value / validMax) * 100))
    : 0;
  
  // Determine color based on score
  const getColor = () => {
    if (percentage >= 80) return "bg-success";
    if (percentage >= 60) return "bg-info";
    if (percentage >= 40) return "bg-warning";
    if (percentage >= 20) return "bg-[hsl(var(--chart-5))]";
    return "bg-destructive";
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className="flex-1 min-w-[80px]">
        <Progress 
          value={percentage} 
          className="h-2"
          indicatorClassName={getColor()}
        />
      </div>
      {showLabel && (
        <span className="text-sm text-muted-foreground min-w-[3ch] text-right">
          {value}
        </span>
      )}
    </div>
  );
}